

import React, { useState } from "react";
import "./excel.css";

export default function ExcelUpload() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const uploadExcel = async () => {
    if (!file) {
      alert("Please select an Excel file (.xlsx or .xls)");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await fetch("https://agepcoatings.com/eacuploadedexcl", {
        method: "POST",
        body: formData
      });

      if (!res.ok) {
        throw new Error("Server error");
      }

      const data = await res.json();
      console.log("API response:", data);

      setLoading(false);

      if (data.success === true) {
        alert(`Successfully inserted ${data.inserted} schedules ✔`);
      } else {
        alert("Upload failed ❌");
      }
    } catch (err) {
      setLoading(false);
      alert("Error while uploading Excel file ❌");
      console.error(err);
    }
  };

  return (
    <div className="container eca-excl">
      <h2>Upload EAC Excel Schedule</h2>

      <input
        type="file"
        accept=".xlsx,.xls"
        onChange={(e) => setFile(e.target.files[0])}
        style={{ marginBottom: 10 }}
      />

      <br />

      <button
        onClick={uploadExcel}
        disabled={loading}
        style={{
          padding: "10px 20px",
          background: loading ? "#ccc" : "#ee5e23",
          color: "#fff",
          border: "none",
          borderRadius: 25,
          cursor: "pointer"
        }}
      >
        {loading ? "Uploading..." : "Upload Excel"}
      </button>
    </div>
  );
}
